import React from 'react';


const TimelineDivider = () => (
    <div className="absolute top-4  ml-timelineScale w-px h-full bg-blueGray-900"></div>
)

export default TimelineDivider;